// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3wraM","notes":"Notes_notes__3B5s1","note":"Notes_note__3lMdf","markdown":"Notes_markdown__1N9mz"};